<template>
  <data-list
    ref="dataList"
    class="content"
    url="/activity/activity-gift-spec"
    entity-name="礼品规格"
    add-btn="新增"
    hide-show-detail
    :hide-action="!editable"
    :before-edit="beforeEdit"
    :modal-width="480"
    :modal-form="modalForm"
    :before-update="beforeUpdate"
    :query="query"
    :action="action"
    :columns="columns"
    :rules="rules">
    <template v-slot:query="{form}">
      <a-form-model-item label="">
        <a-input v-model="form.name" placeholder="输入礼品规格查询" style="width: 200px"></a-input>
      </a-form-model-item>
    </template>
    <template v-slot:edit="{form}">
      <a-form-model-item label="礼品规格" prop="name">
        <a-input v-model="form.name" placeholder="请输入礼品规格"></a-input>
      </a-form-model-item>
      <a-form-model-item label="规格描述" prop="describe">
        <a-input v-model="form.describe" placeholder="请输入规格描述"></a-input>
      </a-form-model-item>
      <a-form-model-item label="礼品清单" prop="giftList">
        <gift-list v-model="form.giftList" ></gift-list>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
    import {giftColumns} from "../../../common/activity/gift";
    import mixins from "../mixins";

    export default {
        name: "GiftType",
        data() {
            return {
                columns: giftColumns,
                rules: {
                    name: [{ required: true, message: '请输入礼品规格', trigger: 'blur' }],
                    describe: [{ required: true, message: '请输入规格描述', trigger: 'blur' }],
                    giftList: [{ required: true, message: '请设置礼品清单', trigger: 'change' }],
                },
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                moduleKey: 'gift-type',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            beforeEdit(form, fn) {
                if(form.gift_list) {
                    try {
                        form.giftList = JSON.parse(form.gift_list)
                    } catch (e) {
                        console.error(e)
                    }
                }
                fn();
            },
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                }
                form.gift_list = form.giftList ? JSON.stringify(form.giftList) : null;
                fn();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
